import React from "react";
import { Dialog, DialogTitle, DialogContent, IconButton } from "@mui/material";
import SalidaForm from "./SalidaForm";
import { Cancel } from "@mui/icons-material";

const SalidaModal = ({ mode, open, handleClose, lockedPedido, pedido }) => {
  return (
    <Dialog fullWidth maxWidth="xl" open={open} onClose={handleClose}>
      <DialogTitle
        sx={{ display: "flex", justifyContent: "flex-end", padding: 0 }}
      >
        <IconButton onClick={handleClose} sx={{ color: "purple" }}>
          <Cancel />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <SalidaForm mode={mode} handleClose={handleClose} lockedPedido={lockedPedido} pedido={pedido} />
      </DialogContent>
    </Dialog>
  );
};
export default SalidaModal;
